import React, { useEffect, useState, useRef } from 'react';

/**
 * Lightweight canvas-free confetti burst.
 * Renders a fixed-position container with N small divs that animate outward + fall.
 * Auto-dismisses after `duration` ms.
 */
export default function Confetti({ show, onDone, message = 'NEW PB!', duration = 1800 }) {
  const [visible, setVisible] = useState(show);
  const doneRef = useRef(onDone);
  doneRef.current = onDone;

  useEffect(() => {
    if (show) {
      setVisible(true);
      const t = setTimeout(() => {
        setVisible(false);
        doneRef.current?.();
      }, duration);
      return () => clearTimeout(t);
    }
  }, [show, duration]);

  if (!visible) return null;

  // Generate confetti pieces once per burst
  const pieces = Array.from({ length: 42 }).map((_, i) => {
    const angle = (Math.PI * 2 * i) / 42 + Math.random() * 0.4;
    const distance = 120 + Math.random() * 140;
    const dx = Math.cos(angle) * distance;
    const dy = Math.sin(angle) * distance;
    const colors = ['#C0392F', '#1E5AA0', '#F39C12', '#27AE60', '#191C21', '#EDEAE3'];
    const color = colors[i % colors.length];
    const size = 6 + Math.random() * 6;
    const rot = Math.random() * 540 - 270;
    return { dx, dy, color, size, rot, delay: Math.random() * 60 };
  });

  return (
    <div className="pb-confetti-root" aria-hidden="true">
      <div className="pb-message">
        <span>{message}</span>
      </div>
      <div className="pb-confetti-burst">
        {pieces.map((p, i) => (
          <span
            key={i}
            className="pb-confetti-piece"
            style={{
              backgroundColor: p.color,
              width: `${p.size}px`,
              height: `${p.size * 0.4}px`,
              transform: `translate(-50%, -50%)`,
              '--dx': `${p.dx}px`,
              '--dy': `${p.dy}px`,
              '--rot': `${p.rot}deg`,
              animationDelay: `${p.delay}ms`,
            }}
          />
        ))}
      </div>
    </div>
  );
}
